import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { get, post } from "../../Services/ApiHandler";
import { URL } from "../../Services/Constant";

const InApp = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [appVersion, setAppVersion] = useState("");

  const getPermissionsList = async () => {
    get(URL.APP_VERSION_LIST)
      .then((res) => {
        if (res?.status == "success") {
          let finder = res?.data?.find((i) => i?.type == 1);
          if (finder?.id) {
            setAppVersion(finder?.setting_value);
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const Add = async () => {
    if (appVersion?.length == 0) {
      toast.error("Please Enter App Version");
    } else {
      const formdata = new FormData();
      formdata.append("setting_value", appVersion);
      post(URL.APP_VERSION_ADD, formdata)
        .then((res) => {
          if (res?.status == "success") {
            toast.success(res?.message);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  useEffect(() => {
    getPermissionsList();
  }, []);

  return (
    <div className="dashRightView">
      <div className="">
        <div className="d-flex ac-jb">
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              App Version<span className="text-danger">*</span>
            </p>
            <input
              className="input-box"
              name="app_version"
              value={appVersion}
              onChange={(e) => setAppVersion(e.target.value)}
              type="text"
              placeholder="App Version"
            />
          </div>
        </div>
        <div className="d-flex ac-jb">
          <button
            onClick={() => {
              Add();
            }}
            className="add-btn white f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
          >
            {loader && (
              <div
                class="spinner-border spinner-border-sm "
                role="status"
                style={{ marginRight: "5px" }}
              />
            )}
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default InApp;
